import React from 'react';
import { preferencesGroupsStorage } from '../../services/preferencesGroupsStorage';
import { preferencesGroupsService } from '../../services/preferencesGroupsService';
import { useTranslation } from 'react-i18next';
import Checkbox from "../Checkbox";

const AssignPreferenceGroupsListItem = ({ groupId }) => {
    const { i18n } = useTranslation();
    const changeSelectedGroups = () => {
        preferencesGroupsStorage.changeSelectedPreferenceGroups(groupId);
    };

    return (
        <tr className="preference__modal-row">
            <td className="preference__users-item preference__modal-item_small" onClick={changeSelectedGroups}>
                <Checkbox
                    checked={preferencesGroupsStorage.getSelectedList().find(it => it.id === groupId) !== undefined}
                    handleChecked={() => {}}/>
            </td>
            <td className="preference__modal-item">
                {preferencesGroupsService.getLocalization(i18n.resolvedLanguage, preferencesGroupsStorage.getById(groupId), false)}
            </td>
        </tr>
    );
};

export default AssignPreferenceGroupsListItem;
